export default function(calories) {
  return {
    type: "SET_CALORIES",
    calories
  }
}

// export default function(weight) {
//   return {
//     type: "SET_WEIGHT",
//     age
//   }
// }
//
// export default function(age) {
//   return {
//     type: "SET_AGE",
//     age
//   }
// }



// WEBPACK FOOTER //
// ./src/actions/setCalories.js